export async function fetchScopeFromCms({ cmsBaseUrl, scope, country, language }, type) {
    const { href: serviceUrl } = new URL(`service/${type}/${scope}/${country.toLowerCase()}/${language.toLowerCase()}`, cmsBaseUrl);
    try {
        const response = await fetch(serviceUrl);
        if (response.ok) {
            return await response.json();
        }
        throw new Error(`Responded with ${response.status} ${response.statusText}`);
    }
    catch (error) {
        throw new Error(`Could not fetch ${type} ${serviceUrl}: ${error}`);
    }
}
//# sourceMappingURL=utils.js.map